import type { Posture as PostureData, PostureState } from '../../../shared/types';
import { GAsyncState, GCard, GEyebrow, GH2, GPill, GStatus } from '../design/atoms';
import { fmtAge } from '../fmt';
import { useEnvStore } from '../store/envStore';
import { useResource } from '../store/resourceStore';

const KIND: Record<PostureState, 'ok' | 'warn' | 'err' | 'dim'> = { ok: 'ok', warn: 'warn', bad: 'err', unknown: 'dim' };
const WORD: Record<PostureState, string> = { ok: 'ok', warn: 'attention', bad: 'fix', unknown: 'unknown' };

export function Posture() {
  const env = useEnvStore((s) => s.env);
  const r = useResource<PostureData>(`/api/env/${env}/posture`);
  const counts = { bad: 0, warn: 0, unknown: 0, ok: 0 } as Record<PostureState, number>;
  for (const c of r.data?.checks ?? []) counts[c.state]++;
  return (
    <div style={{ padding: '22px 28px 40px', maxWidth: 1200 }}>
      <GCard padding="18px 20px">
        <div style={{ display: 'flex', alignItems: 'baseline', gap: 12, marginBottom: 12 }}>
          <GH2 size={17}>Security posture</GH2>
          <GEyebrow style={{ fontSize: 12 }}>{r.data ? `${counts.bad} to fix · ${counts.warn} to look at · ${counts.ok} ok · as of ${fmtAge(r.data.asOf)}` : 'live checks, cached two minutes'}</GEyebrow>
          <div style={{ flex: 1 }} />
          <GPill onClick={r.reload} disabled={r.loading}>Check again</GPill>
        </div>
        <GAsyncState busy={r.loading && !r.data} error={r.error} label="Running checks…" onRetry={r.reload} />
        {r.data && (
          <table className="pd">
            <thead><tr><th>State</th><th>Check</th><th>Why</th></tr></thead>
            <tbody>{r.data.checks.map((c) => (
              <tr key={c.id}>
                <td style={{ whiteSpace: 'nowrap' }}><GStatus kind={KIND[c.state]} label={WORD[c.state]} /></td>
                <td style={{ fontFamily: 'var(--ff-code)', fontSize: 12.5 }}>{c.label}</td>
                <td style={{ color: 'var(--fg-2)' }}>{c.detail}{c.link && <div style={{ fontFamily: 'var(--ff-code)', fontSize: 11.5, color: 'var(--fg-4)', marginTop: 2 }}>{c.link}</div>}</td>
              </tr>
            ))}</tbody>
          </table>
        )}
      </GCard>
    </div>
  );
}
